import React from 'react';
import { addDataLayerEntry } from '@printdeal/data-layer-manager';
import { Brand, Link } from '@printdeal/ui-library';
import { FormattedMessage, useIntl } from 'react-intl';

const TrustPilot = () => {
  const intl = useIntl();

  const handleLinkClick = () => {
    addDataLayerEntry(
      'trustpilot_click',
      {
        contentType: 'navigation_header_usp_bar',
        locale: intl.locale,
      },
    );
  };

  return (
    <Link
      href="https://nl.trustpilot.com/review/www.drukwerkdeal.nl"
      variant="secondary"
      className="pd-whitespace-nowrap pd-text-sm pd-font-normal"
      onClick={handleLinkClick}
      target="_blank"
    >
      <FormattedMessage
        id="trustpilot.score.reviewAmount"
        defaultMessage="<strong>4.5</strong> out of 5 | 6487 reviews"
        values={{
          strong: (chunks) => <strong>{chunks}</strong>,
        }}
      />
      <Brand brand="trustpilot" className="pd-h-5" />
    </Link>
  );
};

export default TrustPilot;
